import React from 'react';
export function FAQSection() {
  const faqs = [{
    q: '¿Es un libro físico?',
    a: 'No. Es un PDF digital (descarga inmediata).'
  }, {
    q: '¿Esto es consejo médico?',
    a: 'No. Es contenido educativo. Consulta a un profesional de salud.'
  }, {
    q: '¿Puedo leerlo en el celular?',
    a: 'Sí. Está diseñado para leerse en móvil.'
  }, {
    q: '¿Cómo recibo el archivo?',
    a: 'Después del pago recibes un enlace de descarga (y normalmente un correo con el recibo).'
  }];
  return <section className="py-20 px-4 bg-[#141414]" data-id="element-34">
      <div className="max-w-3xl mx-auto" data-id="element-35">
        <h2 className="text-3xl font-serif text-center text-white mb-12" data-id="element-36">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-6" data-id="element-37">
          {faqs.map((faq, idx) => <div key={idx} className="border-b border-[#2a2a2a] pb-6 last:border-0" data-id="element-38">
              <h3 className="text-lg font-medium text-white mb-2" data-id="element-39">{faq.q}</h3>
              <p className="text-[#888]" data-id="element-40">{faq.a}</p>
            </div>)}
        </div>
      </div>
    </section>;
}